var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const SRC_TYPE_HTML = "html";
const SRC_TYPE_URL = "url";
const MAX_ALIGNMENT_WIDTH = 739;
const MIN_WIDTH = 35;
const INIT_WIDTH = 350;
const MAX_WIDTH = 940;
const MIN_HEIGHT = 35;
const INIT_HEIGHT = 550;
const MAX_HEIGHT = 1200;
const MAX_HEIGHT_INPUT = 9999;
const DEFAULTS_CONFIG = { alignment: "center" };
const htmlButtonsTypes = { html: "html", adsense: "adsense" };
const adsenseDefaults = () => {
  return defaults(true);
};
const defaults = (isAdsense) => {
  return {
    srcType: SRC_TYPE_HTML,
    src: "",
    config: __spreadValues(__spreadValues({}, DEFAULTS_CONFIG), isAdsense && { isAdsense })
  };
};
const DEFAULTS_VIEWER = {};

export { DEFAULTS_CONFIG, DEFAULTS_VIEWER, INIT_HEIGHT, INIT_WIDTH, MAX_ALIGNMENT_WIDTH, MAX_HEIGHT, MAX_HEIGHT_INPUT, MAX_WIDTH, MIN_HEIGHT, MIN_WIDTH, SRC_TYPE_HTML, SRC_TYPE_URL, adsenseDefaults, defaults, htmlButtonsTypes };
//# sourceMappingURL=defaults.js.map
